// extracted by mini-css-extract-plugin
export default {"list":"tradition_list__RAYen"};